//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import { Chip     } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';

// === HOOKS ===
import { useTaskMonitoring } from 'pages/Admin/ServerPanel/hooks/useMonitorStatus';

//#endregion

//-----------------------------------------------------------------
export function TaskMonitorStatus() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const [is_monitoring] = useTaskMonitoring();

  const icon  = is_monitoring ? <CheckCircle /> : <Error />;
  const label = is_monitoring ? 'AI-Cloud is active' : 'AI-Cloud is not active';
  const color = is_monitoring ? theme.palette.success.main : theme.palette.error.main;

  //#endregion

  //#region [STYLES]

  const _styles = {
    monitor_chip: {
      backgroundColor: color,
      width  : '15rem' ,
      margin : '0.5rem',
    }
  }

  const MONITOR_CHIP = {
    sx    : _styles.monitor_chip,
    size  : 'small' ,
    icon  : icon    ,
    label : label   ,
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (<Chip {...MONITOR_CHIP } />)
  };

  //#endregion

  return display();
}